const React = require('react');
const {requestAnimationFrame, cancelAnimationFrame} = require('../../polyfills/requestAnimationFrame');

/**
 * User: Oleg Kamlowski <oleg.kamlowski@thomann.de>
 * Date: 02.12.2016
 * Time: 15:40
 *
 * do this by css3 natively?
 * https://github.com/bentatum/react-fade
 */
export default class Transition extends React.Component {

    constructor(props) {
        super(props);

        this.frame = null;

        this.state = {
            active: props.active
        };
    }

    /**
     * Initial transition
     */
    componentDidMount() {
        let {initial} = this.props;

        if (initial) {
            this._execute();
        }
    }

    /**
     * Trigger a transition again,
     * if its monitoredvalue changes, is continuous or has new children
     */
    componentDidUpdate(nextProps) {
        let {monitor} = this.props;

        if (monitor != null) {
            if (!this._deepEqual(monitor, nextProps.monitor)) {
                this._execute();
            }
        }
    }

    /**
     * Deactivate the transition animation frame
     */
    componentWillUnmount() {
        this.setState({
            active: false
        });
    }

    /**
     * Deep Object Inspection.
     * Don't pass large objects to this!
     *
     * @param x
     * @param y
     * @returns {boolean}
     * @private
     */
    _deepEqual(x, y) {
        return ((x && y && typeof x === 'object' && typeof y === 'object')
            ? (Object.keys(x).length === Object.keys(y).length)
                && Object.keys(x).reduce((isEqual, key) => {
                    return isEqual && this._deepEqual(x[key], y[key]);
                }, true)
            : (x === y)
        );
    }

    /**
     * Execute the transition
     *
     * @private
     */
    _execute() {
        if (this.refs.transition == null || !this.props.active) {
            return;
        }

        this._animate(Transition.Type.FADEIN)
    }

    _animate(animation) {
        const {callback = () => {}} = this.props;
        const {active} = this.props;

        if (!active) {
            return;
        }

        let preset = Transition.Presets[animation];
        Object.keys(this.props).map((key) => {
            preset[key] = this.props[key] || preset[key]
        });

        let linear = (a, b, value, factor) => {
            if (factor == null) {
                factor = 1;
            }

            (a < b)
                ? value += (speed * factor)
                : value -= (speed * factor);

            return value;
        };

        const {speed, display} = this.props;
        const {transition} = this.refs;

        transition.style[preset.property] = preset.from + preset.unit;
        transition.style.display = display || "block";

        let tick = () => {
            let next = parseFloat(transition.style[preset.property]);
            next = linear(preset.from, preset.to, next);

            if (active && ((next >= preset.to) && (next <= preset.from)) || (next <= preset.to) && (next >= preset.from)) {
                transition.style[preset.property] = next + preset.unit;

                this.frame = requestAnimationFrame(tick)
            } else {
                cancelAnimationFrame(this.frame);

                transition.style[preset.property] = preset.to + preset.unit;

                if (callback) {
                    callback(animation)
                }
            }
        };

        tick();
    }

    render() {
        let {children, style} = this.props;

        style = style || {};
        // style.overflow = 'hidden';

        return (
            <div
                style={style}
                className="transition"
                ref="transition"
                children={children}
            />
        );
    }
}

Transition.Easing = {
   //todo
};

Transition.Type = {
    FADEIN: 'fade-in',
    FADEOUT: 'fade-out'
};

Transition.Presets = {
    [Transition.Type.FADEIN]: {
        property: 'opacity',
        from: 0,
        to: 1,
        unit: '',
    },
    [Transition.Type.FADEOUT]: {
        property: 'opacity',
        from: 1,
        to: 0,
        unit: '',
    }
};

Transition.Speed = {
    SLOW: 0.001,
    NORMAL: 0.075,
    FAST: 0.2
};

Transition.propTypes = {
    speed: React.PropTypes.oneOf(
        Object.keys(Transition.Speed).map(key => Transition.Speed[key])
    ),
    type: React.PropTypes.oneOf(
        Object.keys(Transition.Type).map(key => Transition.Type[key])
    ),
    monitor: React.PropTypes.any,
    callback: React.PropTypes.func,
    continuous: React.PropTypes.bool,
    initial: React.PropTypes.bool,
    active: React.PropTypes.bool,
    display: React.PropTypes.string,
    style: React.PropTypes.object,
    sequential: React.PropTypes.bool,
};

Transition.defaultProps = {
    speed: Transition.Speed.NORMAL,
    type: Transition.Type.FADEIN,
    callback: () => {},
    continuous: true,
    active: true,
    initial: true,
    monitor: null
};



// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/Transition.jsx